// extracted by mini-css-extract-plugin
export default {"container":"style_container__o7DxP","card-item":"style_card-item__waXUa","featured-in-xu":"style_featured-in-xu__FUAvx"};